import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { NextPage } from 'next'
import Head from 'next/head'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAccount } from 'wagmi'
import { getMyInvitations } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { message } from '~/components/Message'
import { truncateAddress } from '~/utils/truncateAddress'
import { StyledLonPageHelper } from '../../styled'
import InvitationTable from '../InvitationTable'
import { StyledInvitationWrapper } from './styled'
import Link from 'next/link'
import { ASSET_PREFIX } from '~/constants/env'
import { useTheme } from 'styled-components'

const Invitations: NextPage = () => {
  const [myData, setMyData] = useState(null)
  const [sortBy, setSortBy] = useState('invited_at')
  const [sortOrder, setSortOrder] = useState('')
  const [loading, setLoading] = useState(false)
  const theme = useTheme()

  const { t } = useTranslation()
  const { address } = useAccount()

  useEffect(() => {
    if (address) {
      setLoading(true)
      getMyInvitations(
        address,
        `${sortOrder}${sortBy}`,
        myData ? myData.invitations?.length : 0,
      )
        .then((result) => {
          setMyData(result)
          setLoading(false)
        })
        .catch((error) => {
          message.error(error.message)
        })
    }
  }, [address, sortBy, sortOrder])

  return (
    <StyledLonPageHelper>
      <Head>
        <title>{t('meta_lon_trade_title')}</title>
        <meta name="description" content={t('meta_lon_trade_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledInvitationWrapper>
        <div className="invitations-inner">
          <div className="bread-thumb">
            <Link href="/lon">LON</Link>
            <img src={`${ASSET_PREFIX}/images/right-arrow-gray.svg`} alt="" />
            <Link href="/lon/mining/trade">{t('trade_mining')}</Link>
            <img src={`${ASSET_PREFIX}/images/right-arrow-gray.svg`} alt="" />
            <span>{t('invitation_record')}</span>
          </div>
          {!address && (
            <div className="placeholder">
              <img
                src={`${ASSET_PREFIX}/images/lon/tokenlon-placeholder.svg`}
                alt=""
              />
              <p>{t('no_data')}</p>
            </div>
          )}
          {address ? (
            <section className="card-wrap invitation-overview">
              <div>
                <dt>{t('total_invited_friends')}</dt>
                <dd>{myData ? myData.total : '~'}</dd>
              </div>
              <div>
                <dt>{t('total_activated_friends')}</dt>
                <dd>{myData?.activated ?? '0'}</dd>
              </div>
              <div>
                <dt>{t('bond_status')}</dt>
                <dd className="address">
                  {myData?.inviter
                    ? truncateAddress(myData?.inviter)
                    : t('unbond')}
                </dd>
              </div>
            </section>
          ) : null}
          {address ? (
            <section
              className="card-wrap"
              style={{ marginTop: 20, flexFlow: 'column nowrap' }}
            >
              <InvitationTable
                data={myData}
                sortBy={sortBy}
                sortOrder={sortOrder}
                setSortBy={setSortBy}
                setSortOrder={setSortOrder}
                setMyData={setMyData}
              />
              {loading && (
                <div className="loading-wrap">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 50, color: theme.colors.primary }}
                        spin
                      />
                    }
                    style={{ marginRight: 10 }}
                  />
                </div>
              )}
              {myData && myData.invitations?.length !== myData.total && (
                <p
                  className="load-more"
                  onClick={() => {
                    setLoading(true)
                    getMyInvitations(
                      address,
                      `${sortOrder}${sortBy}`,
                      myData?.invitations?.length,
                    ).then((result) => {
                      setMyData({
                        ...myData,
                        invitations: [
                          ...myData.invitations,
                          ...result.invitations,
                        ],
                      })
                      setLoading(false)
                    })
                  }}
                >
                  {t('load_more')}
                </p>
              )}
            </section>
          ) : null}
        </div>
      </StyledInvitationWrapper>
      <Footer />
    </StyledLonPageHelper>
  )
}

export default Invitations
